module.exports = __webpack_public_path__ + "img/bondlogo-grey.24b28e2d.png";